// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"138":"24af14a3","500":"2e85cd94","688":"43e2c47e","992":"f9dfea1e"}[chunkId] + ".chunk.css";
};